module.exports = __webpack_public_path__ + "static/img/anchor_tip.58e3973.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/anchor_tip.gif
// module id = zU0G
// module chunks = 57